export function getReviewDataStructure(data) {
    const { review_rating } = data;
    const reviewData = review_rating?.map((data) => {
        const { item_name = '', item_url = '', image_url = '', review = '', full_name = '', verified_buyer, review_date, rating, avg_rating, id } = data || {};
        return {
            productName: item_name,
            productUrl: item_url,
            productImage: image_url,
            headline: '',
            review: review,
            authorMedia: {
                type: 'image',
                link: 'https://codrops-1f606.kxcdn.com/codrops/wp-content/uploads/2020/02/04.jpg?x99913',
            },
            authorName: full_name,
            authorDesignation: '',
            ratingCount: rating,
            avgRating: avg_rating,
            date: review_date,
            isVisible: true,
            verifiedBuyer: verified_buyer,
            id
        }
    }
    )
    return reviewData;
}
// Here pTestimonial is product testimonial and ptData is Product testimonial data
export function getCategoryProductTestimonial(categoryPTestimonial) {
    const dropdownDownData = [];
    const catItemReviewMap = {};
    categoryPTestimonial?.forEach((ptData) => {
        const { category, items } = ptData;
        dropdownDownData?.push({
            value: category.id,
            text: category.name
        })
        items?.forEach((ptItemData) => {
            catItemReviewMap[category.id] = [
                ...(catItemReviewMap?.[category.id] || []),
                {
                    productImage: ptItemData?.image_url,
                    productName: ptItemData?.name,
                    productId: ptItemData?.id,
                    categoryId: category.id,
                    reviews: ptItemData?.store_item_review_rating?.review_rating,
                    reviewsCount: ptItemData?.store_item_review_rating?.ratings_count
                }
            ]
        })
    })
    return {
        dropdownDownData,
        catItemReviewMap
    }
}

export function createCategoryTestimonialDropdownConfig(dropdownData) {
    return {
        dropdownData,
        placeholder: 'Select Category',
        customChildRender: false,
        key: 'category',
        forCategory: true,
        customClass: 'tw-w-[200px]'
    }
}
